// extracted by mini-css-extract-plugin
export default {"bubble":"Project_bubble__Pa3UR","descriptionContainer":"Project_descriptionContainer__e4mpR","titleIcons":"Project_titleIcons__bUOnJ","icons":"Project_icons__FD3ut"};